import { createDecorator } from '../../instantiation/common/instantiation.js';
const IIgnoredExtensionsManagementService = ( createDecorator('IIgnoredExtensionsManagementService'));
export { IIgnoredExtensionsManagementService };
